export const homeRoomTypes = {
    'en': [
        { title: 'Any Bedrooms', value: '0' },
        { title: 'Studio', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'th': [
        { title: 'นอน', value: '0' },
        { title: 'สตูดิโอ', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'cn': [
        { title: '卧室无限', value: '0' },
        { title: '开建户型', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'ru': [
        { title: 'Спальни', value: '0' },
        { title: 'Студия', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'de': [
        { title: 'Schlafzimmer', value: '0' },
        { title: 'Studio', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'fr': [
        { title: 'Chambres', value: '0' },
        { title: 'Studio', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'it': [
        { title: 'Camere da letto', value: '0' },
        { title: 'Monolocale', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'ja': [
        { title: '寝室数指定なし', value: '0' },
        { title: 'スタジオ / ワンルーム', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'ko': [
        { title: '침실 수 무관', value: '0' },
        { title: '스튜디오', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'es': [
        { title: 'Dormitorios', value: '0' },
        { title: 'Estudio', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'tr': [
        { title: 'Yatak Odası', value: '0' },
        { title: 'Stüdyo', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'he': [
        { title: 'חדרי שינה', value: '0' },
        { title: 'סטודיו', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ],
    'ar': [
        { title: 'غرف النوم', value: '0' },
        { title: 'استوديو', value: 'studio' },
        { title: '1', value: '1' },
        { title: '2', value: '2' },
        { title: '3', value: '3' },
        { title: '4', value: '4' },
        { title: '5+', value: '5' },
    ]
}